var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panoMainViewVideo" }, [
    _c("div", {
      ref: "domRef",
      staticClass: "videoDomRef",
      style: {
        visibility: `${
          (_vm.mainViewUser.isScreenInMainView &&
            !_vm.mainViewUser.screenOpen) ||
          (!_vm.mainViewUser.isScreenInMainView && _vm.mainViewUser.videoMuted)
            ? "hidden"
            : "visible"
        }${
          _vm.isUserMe
            ? "transform: rotateY(180deg)" // 本地预览翻转
            : ""
        }`,
      },
    }),
    _vm._v(" "),
    _vm.mainViewUser.locked
      ? _c("div", { staticClass: "userLocked", on: { click: _vm.onUnLock } }, [
          _c("span", { staticClass: "iconfont icon-lock1" }),
          _vm._v(" 取消锁定\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.mainViewUser.videoMuted &&
              !_vm.mainViewUser.isScreenInMainView,
            expression:
              "mainViewUser.videoMuted && !mainViewUser.isScreenInMainView",
          },
        ],
        staticClass: "userNameMainView",
        style: { fontSize: "80px" },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.mainViewUser.userName || _vm.mainViewUser.userId) +
            "\n    " +
            _vm._s(_vm.isUserMe && "(Me)") +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "userVideoStatus" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.mainViewUser.videoMuted ||
                _vm.mainViewUser.isScreenInMainView,
              expression:
                "!mainViewUser.videoMuted || mainViewUser.isScreenInMainView",
            },
          ],
          staticClass: "userVideoUserName",
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.mainViewUser.userName || _vm.mainViewUser.userId) +
              "\n      " +
              _vm._s(_vm.mainViewUser.isScreenInMainView ? "(Share)" : "") +
              "\n      " +
              _vm._s(_vm.isUserMe ? "(Me)" : "") +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.mainViewUser.audioMuted
        ? _c("i", { staticClass: "iconfont icon-microphone-slash" })
        : _c("i", {
            staticClass: "iconfont icon-microphone",
            style: {
              color: _vm.mainViewUser.isSpeaking ? "#00ff00" : "#fff",
              fontSize: "14px",
            },
          }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/userVideo/MainView.vue?vue&type=template&id=0e1608ff&
// module id = null
// module chunks = 